module.exports = __webpack_public_path__ + "img/心理状态.d1d29d4f.png";